module.exports = __webpack_public_path__ + "static/media/emojis_26.08245677.svg";